export const BASE_URL = process.env.REACT_APP_BASEURL || "";
export const ENVIRONMENT = process.env.NODE_ENV;
export const RECAPTCHA_SITE_KEY = process.env.RECAPTCHA_SITE_KEY;
export const serverAddress = new URL(BASE_URL);
export const getFullAPIBase = () => BASE_URL;
